import { ModuleListItem, SETUP_APP_PAGE_BASE_PATH } from 'src/constants';
import { ModuleType } from 'src/constants/dataTypes/moduleDataTypes';
import history from 'src/history';

export const getEditModuleUrl = ({
  moduleType,
  moduleId,
  appId,
}: {
  moduleType: ModuleType;
  moduleId: string;
  appId?: string;
}) =>
  `${SETUP_APP_PAGE_BASE_PATH}?moduleType=${moduleType}&moduleId=${
    moduleId
  }${appId ? `&appId=${appId}` : ''}`;

export const redirectToEditModule = (module: ModuleListItem) => {
  history.push(
    getEditModuleUrl({
      moduleType: module.type,
      moduleId: module.id,
      appId: module.appId,
    }),
  );
};
